import { useContext } from 'react';
import AdvancedSearchContext from './AdvancedSearchContext';

const useAdvancedSearch = () => useContext(AdvancedSearchContext);

export default useAdvancedSearch;
